import { AI_ROUTE } from '@/config/routes/ai';

export default [
  {
    path: AI_ROUTE.ROUTE_PATH,
    name: AI_ROUTE.ROUTE_NAME,
    components: {
      default: () => import(/* webpackChunkName: "container-ai" */ '@/views/ai/AiIndexContainer.vue')
    },
    meta: {
      privileges: AI_ROUTE.PRIVILEGES,
      fillHeight: true,
    },
  },
  {
    path: `${AI_ROUTE.ROUTE_PATH}/:conversationId`,
    name: `${AI_ROUTE.ROUTE_NAME}.conversation`,
    components: {
      default: () => import(/* webpackChunkName: "container-ai" */ '@/views/ai/AiIndexContainer.vue')
    },
    meta: {
      privileges: AI_ROUTE.PRIVILEGES,
      fillHeight: true,
    },
  }
];
